import { getIssueStatus, getIssueState } from 'shared/constants/issues';
import intl from 'utils/intl';
import logger from 'utils/logger';

const log = logger.createLogger('OrganizationLogsUtils');

const LOG_TYPE = {
  SIGNIN_ORGANIZATION: 'signin-organization',
  DOWNLOAD: 'download',
  NEW: 'new',
  COMMENT: 'comment',
  REPORT: 'report',
  ASSIGN: 'assign',
  UNASSIGN: 'unassign',
  STATUS: 'status',
  STATE: 'state',
  STAR: 'star',
  QUESTION: 'question',
  WAIVE: 'waive',
  ADJUSTMENT: 'adjustment',
  REMOVE_ISSUE: 'remove-issue',
  REMOVE_ATTACHMENT: 'remove-attachment',
};

export const generateLogsContents = (type, contents) => {
  switch (type) {
    case LOG_TYPE.SIGNIN_ORGANIZATION:
      return intl.get('logs_text_log_in');
    case LOG_TYPE.DOWNLOAD:
      // Content number 3 is attachement
      if (contents.length > 3) {
        return intl.get('logs_text_download_attachments_from_issue', {
          issue: contents[2],
        });
      }
      return intl.get(
        'logs_text_download_attachments_from_issue_with_comment',
        {
          issue: contents[2],
          comment: contents[3],
        }
      );
    case LOG_TYPE.NEW:
      return intl.get('logs_text_new_issue', {
        issue: contents[2],
        to: contents[3],
      });
    case LOG_TYPE.COMMENT:
      if (contents.length > 3) {
        return intl.get('logs_text_submit_a_comment_to_issue_with_attachment', {
          issue: contents[2],
          attachment: contents[3],
        });
      }
      return intl.get('logs_text_submit_a_comment_to_issue', {
        issue: contents[2],
      });
    case LOG_TYPE.REPORT:
      if (contents.length > 3) {
        return intl.get('logs_text_submit_a_report_to_issue_with_attachment', {
          issue: contents[2],
          attachment: contents[3],
        });
      }
      return intl.get('logs_text_submit_a_report_to_issue', {
        issue: contents[2],
      });
    case LOG_TYPE.ASSIGN:
      return intl.get('logs_text_assign_issue_to_doctor', {
        issue: contents[2],
        doctor: contents[3],
        state: contents[4],
      });
    case LOG_TYPE.UNASSIGN:
      return intl.get('logs_text_remove_doctor_from_issue', {
        issue: contents[2],
        doctor: contents[3],
        state: contents[4],
      });
    case LOG_TYPE.STATUS:
      return intl.get('logs_text_change_status_of_issue', {
        issue: contents[2],
        status: getIssueStatus(contents[3]),
      });
    case LOG_TYPE.STATE:
      return intl.get('logs_text_change_state_of_issue', {
        issue: contents[2],
        state: getIssueState(contents[3]),
      });
    case LOG_TYPE.STAR:
      return intl.get('logs_text_star_issue', {
        issue: contents[2],
      });
    case LOG_TYPE.QUESTION:
      return intl.get('logs_text_question_issue', {
        issue: contents[2],
      });
    case LOG_TYPE.WAIVE:
      return intl.get('logs_text_waive_issue', {
        issue: contents[2],
      });
    case LOG_TYPE.ADJUSTMENT:
      return intl.get('logs_text_adjustment_issue', {
        issue: contents[2],
      });
    case LOG_TYPE.PDF:
      return intl.get('logs_text_download_pdf_invoice', {
        issue: contents[2],
      });
    case LOG_TYPE.REMOVE_ISSUE:
      return intl.get('logs_text_remove_issue', {
        issue: contents[2],
      });
    case LOG_TYPE.REMOVE_ATTACHMENT:
      return intl.get('logs_text_remove_attachment', {
        issue: contents[2],
        attachment: contents[3],
      });
    default:
      log.warn('generateLogsContents', 'Unknown log type', type);
      return '';
  }
};
